import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { TAGS_QUERY_KEY } from "./useTags";

type TagResponse = components["schemas"]["TagResponse"];

export type RestoreTagVariables = {
  tagId: string;
};

export function useRestoreTag() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<TagResponse, Error, RestoreTagVariables>({
    mutationFn: async ({ tagId }) => {
      const { data, error } = await client.POST("/api/tags/{tag_id}/restore", {
        params: { path: { tag_id: tagId } },
      });
      if (error !== undefined) {
        throw new Error(`Failed to restore tag ${tagId}`);
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TAGS_QUERY_KEY });
    },
  });
}
